export class UpdateLocationStateError extends Error {

}
